import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import MainTitle from "../components/MainTitle";
import { formatPrice } from "../utils/format";

const PurchaseInProcess = () => {

    const navigate = useNavigate();
    const params = useParams();

    const { items, deliveryDate, deliveryDirection, clientData} = useContext(CheckoutContext);

    const [applyDiscount, setApplyDiscount] = useState(false);
    const [total, setTotal] = useState(null);
    const [totalWithDiscount, setTotalWithDiscount] = useState();

    useEffect(() => {
        //if total quantity is >= 4, then change applyDiscount to true
        let total_quantity = 0;
        for (let i = 0; i < items.length; i++) {
            total_quantity += items[i].quantity;
        }
        if (total_quantity >= process.env.REACT_APP_KILOS_NUMBER_DISCOUNT) {
            setApplyDiscount(true);
        } else {
            setApplyDiscount(false);
        }
        calculateTotalPrices();
    }, [items]);

    function calculateTotalPrices () {
        let total = 0;
        for (let i = 0; i < items.length; i++) {
            total += items[i].total;
        }
        setTotal(total);
        const MultipleToDiscountAsNumber = Number((1 - process.env.REACT_APP_KILOS_NUMBER_DISCOUNT_PERCENTAGE).toFixed(10));
        setTotalWithDiscount(total * MultipleToDiscountAsNumber);
    }


    return (
        <div className="min-h-screen bg-[#f6f6ee] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Estado */}
            <div className="px-4 pt-6 pb-1 text-center">
                <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-3">
                    <svg className="w-7 h-7 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                    </svg>
                </div>
                <h1
                    className="font-serif text-[22px] font-bold text-[#1e2a1a] leading-tight"
                >
                    ¡Gracias por tu compra, {clientData.name}!
                </h1>
                <p className="text-[12px] text-gray-400 mt-1 px-4">
                    Tu pago está pendiente de aprobación. Una vez se acredite, se procesará tu orden.
                </p>
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 my-5">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">detalle del pedido</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            <div className="flex flex-col gap-3">

                {/* Productos */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex items-center gap-2 bg-[#f6f6ee] border-b border-gray-100">
                        <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
                        </svg>
                        <p className="text-sm font-semibold text-[#1e2a1a]">Productos</p>
                    </div>
                    <div className="px-4 py-2 divide-y divide-gray-50">
                        {items.map((item) => (
                            <div key={item.product.id} className="flex items-center justify-between gap-3 py-2.5">
                                <p className="text-[13px] text-[#1e2a1a] leading-tight">
                                    <span className="font-semibold">{item.quantity} </span>
                                    {item.product.type} de {item.product.name}
                                </p>
                                <span className="text-[11px] font-semibold text-amber-700 bg-amber-50 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                                    pendiente
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Despacho */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex items-center gap-2 bg-[#f6f6ee] border-b border-gray-100">
                        <svg className="w-4 h-4 text-[#4a7c2f] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
                        </svg>
                        <p className="text-sm font-semibold text-[#1e2a1a]">Despacho</p>
                    </div>
                    <div className="px-4 py-3 flex flex-col gap-2">
                        <div>
                            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Día</p>
                            <p className="text-[13px] text-[#1e2a1a] font-medium">
                                {deliveryDate[1]} {deliveryDate[2]} de {deliveryDate[3]}
                            </p>
                        </div>
                        <div>
                            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Dirección</p>
                            <p className="text-[13px] text-[#1e2a1a] font-medium">
                                {deliveryDirection.streetName} {deliveryDirection.streetNumber}{deliveryDirection.houseNumber ? ` (Casa ${deliveryDirection.houseNumber})` : ""}{deliveryDirection.houseNumber ? ` (Dpto ${deliveryDirection.departmentNumber})` : ""}, {deliveryDirection.commune}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Totales */}
                <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                    <div className="px-4 py-3 flex flex-col gap-1.5">
                        {applyDiscount && (
                            <div className="flex items-center justify-between">
                                <span className="text-[13px] text-gray-500">Total sin descuento</span>
                                <span className="text-[13px] text-gray-400 line-through">{formatPrice(total)}</span>
                            </div>
                        )}
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-semibold text-[#1e2a1a]">Total pendiente de pago</span>
                            <span className="text-[17px] font-bold text-[#2f5a2e]">
                                {formatPrice(applyDiscount ? totalWithDiscount : total)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Volver */}
            <div className="px-4 mt-6">
                <button
                    onClick={() => navigate("/")}
                    className="w-full py-3 rounded-xl text-sm font-semibold bg-[#2f5a2e] hover:bg-[#3f7a3a] active:scale-[0.98] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20 transition-all duration-150"
                >
                    Volver al inicio
                </button>
            </div>
        </div>
    );
}

export default PurchaseInProcess;
